// This Component displays a list of items
// A show list Item and a h2 title

import { Col, Container, Row } from "react-bootstrap";
import { Spinner } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import styled from "styled-components";
// import ArticleItem from "./ArticleItem";

const ArticleCard = styled(Card)`
  .card-title {
    font-size: 3rem;
  }
  .card-text {
    text-align: left;
  }
`;

function ArticleItem({ name, description, image, slug, date }) {
  // date fomatting
  var options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  const publishedDate = new Date(date).toLocaleDateString("fr-FR", options);
  return (
    <ArticleCard>
      <Card.Img variant="top" src={image} />
      <Card.Body>
        <Card.Title>{name}</Card.Title>

        <Card.Text className="u-mt-small">
          {description.slice(0, 190)} ...
        </Card.Text>
        <hr />
        <Card.Text className="d-flex justify-content-between u-mt-small">
          <Link to={`/blog/${slug}`} className="btn btn-blue">
            Lire la suite
          </Link>
          <span>{publishedDate}</span>
        </Card.Text>
      </Card.Body>
    </ArticleCard>
  );
}

function BlogList({ articles, isLoading }) {
  return (
    <Container className="u-mt-medium">
      <Row>
        {isLoading ? (
          <Spinner animation="grow" variant="primary" />
        ) : (
          articles?.map((article) => (
            <Col key={article.slug} lg={8}>
              <ArticleItem
                name={article.title}
                description={article.description}
                slug={article.slug}
                image={article.image}
                date={article.modified}
              />
            </Col>
          ))
        )}
      </Row>
    </Container>
  );
}

export default BlogList;
